<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div
              class="flash-message col-md-4 col-md-offset-4 text-center"
              v-if="flash"
            >
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div id="details" class="row">
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.cityId)"
                  >
                    <label>City</label>
                    <select
                      required
                      name="cityId"
                      class="form-control"
                      v-model="segregationPlant.cityId"
                      :disabled="isCityDisable"
                      v-on:change="getCityLists($event.target.value)"
                    >
                      <option value="" disabled>Select City Name</option>
                      <option v-for="cityId in citys" :value="cityId.id"
                        >{{ cityId.name }}
                      </option>
                    </select>
                    <field-messages
                      name="cityId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">City Name is a required field</div>
                    </field-messages>
                  </validate>
                </div>

                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.plantName)"
                  >
                    <label>Segregation Plant Name</label>
                    <input
                      maxlength="25"
                      type="text"
                      name="plantName"
                      class="form-control"
                      required
                      v-model="segregationPlant.plantName"
                      placeholder="Plant Name"
                      pattern="^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,25}"
                    />
                    <field-messages
                      name="plantName"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        Segregation Plant Name is a required field.
                      </div>
                      <div slot="pattern">
                        Alphabets/Numbers/Special Characters are allowed.
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.user)"
                  >
                    <label>Assign Manager</label>
                    <select
                      required
                      name="user"
                      class="form-control"
                      v-model="segregationPlant.user"
                    >
                      <option value="" disabled>Select Assign Manager</option>
                      <option
                        v-for="manager in managerss"
                        :value="manager.id"
                        >{{ manager.name }}</option
                      >
                    </select>
                    <field-messages
                      name="user"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">
                        Assign Manager is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>

                <div class="row">
                  <div class="location_paddi">
                    <div class="col-sm-6">
                      <div>
                        <location @change-event="setIsDisable" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'segregation' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <button
                class="mr-2 btn gradientbt"
                type="submit"
                @click="createSegregationPlant"
                :disabled="!(formstate.$dirty && formstate.$valid && isDisable)"
                v-if="$route.params && $route.params._id == '0'"
              >
                Save
              </button>
              <button
                class="btn gradientbt mr-5"
                type="submit"
                @click="updateSegregationPlant"
                :disabled="
                  !isDisable && !(formstate.$dirty && formstate.$valid)
                "
                v-if="$route.params && $route.params._id != '0'"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import AddGoogleMap from './AddGoogleMap.vue';

import store from "../../../store";
import { formService, eventBus, segregationService } from "../../../services";
import { EVENTS } from "../../../config";
import { USER_ROLES } from "../../../config";
import { mapState } from "vuex";

import location from "../gmapLocation/location";

export default {
  name: "segregationPlantCreate",
  components: {
    location,
  },
  data() {
    return {
      // marker: {
      //     position: {
      //         lat: 10,
      //         lng: 10
      //     }
      // },
      // center: {
      //     lat: 10,
      //     lng: 10
      // },
      // mapOptions: {
      //     disableDefaultUI: true,
      // },
      isCityDisable: false,
      isDisable: false,
      ready: false,
      USER_ROLES: USER_ROLES,
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: "",
      EVENTS: EVENTS,
      formstate: {},

      segregationPlant: {
        user: "",
        cityId: "",
      },
      oldsegregationPlant: {},
      segregationPlantId: [],
      managerss: {},
      googleLocation: {},
      coordinates: [],
      citys: {},
      // userId: this.$route.params._id,
    };
  },
  mounted: function() {
    this.getCityList();
  },
  methods: {
    fieldClassName: formService.fieldClassName,
    setIsDisable(value) {
      this.isDisable = value;
    },
    // geolocate() {
    //     navigator.geolocation.getCurrentPosition((position) => {
    //         this.marker.position = {
    //             lat: position.coords.latitude,
    //             lng: position.coords.longitude,
    //         };
    //         this.panToMarker();
    //     });
    // },
    // //sets the position of marker when dragged
    // handleMarkerDrag(e) {
    //     this.marker.position = {
    //         lat: e.latLng.lat(),
    //         lng: e.latLng.lng()
    //     };
    // },
    // //Moves the map view port to marker
    // panToMarker() {
    //     this.$refs.mapRef.panTo(this.marker.position);
    //     this.$refs.mapRef.setZoom(18);
    // },
    // //Moves the marker to click position on the map
    // handleMapClick(e) {
    //     this.marker.position = {
    //         lat: e.latLng.lat(),
    //         lng: e.latLng.lng()
    //     };
    // },
    getCityList() {
      if (this.$store.state.auth.user.role.key === "cityAdmin") {
        const { _id, cityName } = this.$store.state.auth.user.cityId;
        this.citys = [
          {
            id: _id,
            name: cityName,
          },
        ];
        this.segregationPlant["cityId"] = _id;
        this.getCityLists(_id);
        this.isCityDisable = true;
        return;
      }
      this.loading = true;
      const params = {};
      let cityList = [];
      // params.page = 1;
      // params.limit = 999;
      this.$cityRepository
        .collectionCitysList(params)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            if (element.status === true) {
              cityList.push({
                name: element.cityName,
                id: element._id,
              });
            }
          });
          cityList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.citys = cityList;
        })
        .catch((error) => {
          this.loading = false;
          console.error("citys.requestFunction-error:", error);
          this.$snotify.error("Get citys list failed", "Error!");
        });
    },

    getCityLists(value) {
      this.segregationPlant["user"] = "";
      this.getManagers(value);
    },

    getManagers(cityId) {
      this.loading = true;
      const params = {
        $embed: ["role"],
      };
      params.$select = ["_id", "firstName", "lastName"];
      params.isActive = true;
      params.cityId = cityId;
      let managerlist = [];
      // params.page = 1;
      // params.limit = 999;
      this.$userRepository
        .list(params)
        .then((res) => {
          this.loading = false;
          res.data.docs.forEach((element) => {
            if (element.role.name === "Plant Manager") {
              managerlist.push({
                name: element.firstName + " " + element.lastName,
                id: element._id,
              });
            }
          });

          managerlist.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });

          this.managerss = managerlist;
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error("Get manager list failed", "Error!");
        });
    },

    getSegregationPlant() {
      const params = {
        // $embed: ['user']
      };
      return this.$segregationDataRepository
        .find(this.$route.params._id, params)
        .then((response) => {
          this.segregationPlant = response.data;
          this.oldsegregationPlant = _.cloneDeep(this.segregationPlant);
          this.$store.dispatch(
            "setBreadcrumbTitle",
            this.segregationPlant.plantName
          );
          let location = {};
          location["name"] = this.segregationPlant.plantLocation;
          location["lat"] = this.segregationPlant.geoloc[0];
          location["long"] = this.segregationPlant.geoloc[1];
          this.getManagers(this.segregationPlant.cityId);
          eventBus.$emit("getgeoLocation", location);
        })
        .catch((error) => {
          this.$snotify.error("Get segregation failed", "Error!");
        });
    },

    createSegregationPlant() {
      this.loading = true;
      this.segregationPlant["plantLocation"] = this.googleLocation.name;
      this.segregationPlant["geoloc"] = this.coordinates;
      return segregationService
        .addSegregationPlant(this.segregationPlant)
        .then((response) => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success(
            `The ${this.segregationPlant.plantName} has been added successfully.`
          );
          this.$router.push("/segregation");
        })
        .catch((error) => {
          this.loading = false;
          if (error.data.message == "PlantLocation already exists") {
            var errorMessage = "Plant Location Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          }else if (error.data.message == "PlantName already exists") {
            var errorMessage = "Plant Name Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          }  else {
            this.$snotify.error("Segregation Plant Create Failed", "Error!");
          }

          // if (error.data.statusCode === 409) {
          //   this.$snotify.error(error.data.message, "Error!");
          // } else {
          //   this.$snotify.error("Segregation Plant Create Failed", "Error!");
          // }
        });
    },

    clearChanges() {
      this.segregationPlant = _.cloneDeep(this.oldsegregationPlant);
      this.formstate._reset();
    },
    updateSegregationPlant() {
      this.loading = true;
      this.segregationPlant.segregationPlantId = this.$route.params._id;
      this.segregationPlant["plantLocation"] = this.googleLocation.name;
      this.segregationPlant["geoloc"] = this.coordinates;
      return segregationService
        .updateSegregationPlant(this.segregationPlant, this.oldsegregationPlant)
        .then((response) => {
          this.loading = false;
          this.flash = false;
          this.formstate._reset();
          this.oldsegregationPlant = _.cloneDeep(this.segregationPlant);
          this.$snotify.success(
            `The ${this.segregationPlant.plantName} has been updated successfully.`
          );
          this.$router.push("/segregation");
        })
        .catch((error) => {
          this.loading = false;
          if (error.data.message == "PlantLocation already exists") {
            var errorMessage = "Plant Location Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          }else if (error.data.message == "PlantName already exists") {
            var errorMessage = "Plant Name Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          }  else {
            this.$snotify.error("Segregation Plant Create Failed", "Error!");
          }
        });
    },
  },
  created() {
    eventBus.$on("geoLocation", (location) => {
      this.googleLocation = location;
      let locationinfo = Object.values(this.googleLocation);
      this.coordinates = locationinfo.splice(0, 2);
    });
    const promises = [];
    this.loading = true;
    // promises.push(this.getManagers());
    if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
      promises.push(this.getSegregationPlant());
    }
    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
      })
      .catch((error) => {
        this.loading = false;
        this.$snotify.error("Create segregationPlant failed", "Error!");
      });
  },
  beforeDestroy() {},

  fieldClassName: function(field) {
    if (!field) {
      return "";
    }
    if ((field.$touched || field.$submitted) && field.$valid) {
      return "has-success";
    }
    if ((field.$touched || field.$submitted) && field.$invalid) {
      return "has-danger";
    }
  },

  // computed: {
  //     ...mapState({
  //         user: state => state.auth.user,
  //     })
  // }
};
</script>

<style scoped>
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red;
}

.mt {
  margin-top: 7px;
}

.gradientbt {
  background: #0f6940;
  color: white;
}

.inputwrapper {
  position: relative;
}

.maps {
  position: absolute;
  top: 7px;
  right: 10px;
}

.vue-map-container {
  width: 100% !important;
}

.location_paddi {
  padding: 0px 30px;
}
</style>



// WEBPACK FOOTER //
// segregationPlantCreate.vue?e7cbde20